import { Component, OnInit } from '@angular/core';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
import { Observable } from 'rxjs';
import { DatosUsuario } from 'src/app/modelos/datosusuario.model';

@Component({
  selector: 'app-seccion-ajustes',
  templateUrl: './seccion-ajustes.component.html',
  styleUrls: ['./seccion-ajustes.component.css']
})
export class SeccionAjustesComponent implements OnInit {
  public datos: Observable<any>;
  public nombre:string;
  public ap:string;
  public am:string;
  public institucion:string;
  public correo:string;
  public contra:string;
  public tarjeta:string;
  public plan:string="aaaaaaaaa";
  public uid:string;
  public infoUsuario:DatosUsuario;
  constructor(private servicio:ServicioFirebaseService) { }

  ngOnInit() {
    this.cargarInformacion();
  }
  cargarInformacion(){
    var calificaciones = [];
    var labels = [];
    this.servicio.afAuth.authState.subscribe(res=>{
      this.correo=res.email;
      this.datos=this.servicio.tomarInformacionUsuario(res.uid);
      this.datos.subscribe((res)=>{
        console.log(res);
        this.nombre=res[0].nombre;
        this.ap=res[0].apellidopaterno;
        this.am=res[0].apellidomaterno;
        this.institucion=res[0].institucion;
        this.tarjeta=res[0].tarjeta;
        this.plan=res[0].plan;
      });
    });
  }
  modificarDatos(){
   
  }
}
